export default __webpack_public_path__ + "static/media/ItemsImg.6e862838.svg";